import { History, Upcoming } from "@mui/icons-material";
import { Box, Stack, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import ChipTabs from "../../../../../components/ChipsTabs";
import Future, { FuturePet } from "../Future";
import Past, { PastPet } from "../Past";

function Wrapper({ children }) {
  return <Stack spacing={2}>{children}</Stack>;
}

export default function AppointmentsTabs() {
  return (
    <Wrapper>
      <UserData />
    </Wrapper>
  );
}

export function PetAppointmentsTab({
  isDeceased = false,
  isOwnerDeleted = false,
}) {
  return (
    <Wrapper>
      <PetData isDeceased={isDeceased} isOwnerDeleted={isOwnerDeleted} />
    </Wrapper>
  );
}

const PET_APPOINTMENTS_TAB_PARAM = "appointmentsTab";
const UPCOMING = "upcoming";
const HISTORY = "history";

// MUI tabs to match the single pet view's own tabs; the tab lives in the URL
function PetData({ isDeceased = false, isOwnerDeleted = false }) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab =
    searchParams.get(PET_APPOINTMENTS_TAB_PARAM) === HISTORY ? HISTORY : UPCOMING;

  const handleTabChange = (event, newValue) => {
    setSearchParams(
      (params) => {
        params.set(PET_APPOINTMENTS_TAB_PARAM, newValue);
        return params;
      },
      { replace: true },
    );
  };

  return (
    <Box width="100%">
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{ "& .MuiTab-root": { textTransform: "none", fontWeight: 600 } }}
      >
        <Tab
          value={UPCOMING}
          iconPosition="start"
          icon={<Upcoming fontSize="small" />}
          label={t("UpcomingAppointments")}
          data-testid="appointment.pet-tabs.upcoming-tab"
        />
        <Tab
          value={HISTORY}
          iconPosition="start"
          icon={<History fontSize="small" />}
          label={t("History")}
          data-testid="appointment.pet-tabs.history-tab"
        />
      </Tabs>
 
      <Box role="tabpanel">
        {activeTab === UPCOMING ? (
          <FuturePet isDeceased={isDeceased} isOwnerDeleted={isOwnerDeleted} />
        ) : (
          <PastPet isDeceased={isDeceased} isOwnerDeleted={isOwnerDeleted} />
        )}
      </Box>
    </Box>
  );
}

function UserData() {
  const content = [<Future />, <Past />];

  return (
    <FutureAndPastChip
      content={content}
      key={"users-future-and-past-appointments"}
    />
  );
}

function FutureAndPastChip({ content }) {
  const labels = ["UpcomingAppointments", "History"];
  const icons = [<Upcoming fontSize="small" />, <History fontSize="small" />];

  return (
    <ChipTabs
      lsKey={"APPOINTMENTS_LS_KEY"}
      tabContent={content}
      tabLabels={labels}
      icons={icons}
      tabTestIds={["appointment.user-tabs.upcoming-tab", "appointment.user-tabs.history-tab"]}
    />
  );
}
